module.exports = __webpack_public_path__ + "static/media/Data1.f13b05af.png";